import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { ListItemText } from '@material-ui/core';
import ListItem, { ListItemProps } from '@material-ui/core/ListItem';

import { Typography } from './Typography';

const messages = defineMessages({
  emptyStateTitle: {
    id: 'components.v2.EmptyStateList.emptyStateTitle',
    defaultMessage: 'No results found',
  },
});

interface EmptyStateListProps extends ListItemProps {}

const EmptyStateList: React.FC<EmptyStateListProps> = ({ ...rest }) => {
  const { formatMessage } = useIntl();

  return (
    <ListItem {...rest}>
      <ListItemText
        disableTypography
        primary={<Typography variant="body1">{formatMessage(messages.emptyStateTitle)}</Typography>}
      />
    </ListItem>
  );
};

export default EmptyStateList;
